import { IconLoading } from '@/assets/icons/icon-loading'
import { useIsDarkTheme } from '@/utils/useTheme'

import LogoBlack from '../../icons/logo-black.svg'
import LogoWhite from '../../icons/logo-white.svg'
import NotificationIcon from '../../icons/notification.svg'
import { IconButton } from './icon-button'

export const ChattingPageLoader = () => {
  const isDark = useIsDarkTheme()

  return (
    <div className="flex h-screen w-full flex-col">
      <div className="relative flex h-[55px] max-w-full items-center overflow-hidden border-b bg-card p-2">
        <div className="relative h-[38px] w-[100px] overflow-hidden rounded-md border border-primary-500 bg-primary-50 px-5 py-2 text-sm font-semibold opacity-55 dark:bg-secondary-800 dark:hover:border-primary-500 dark:hover:bg-secondary-800">
          New tab
        </div>
        <div className="ml-auto flex gap-2">
          <IconButton
            icon={NotificationIcon}
            iconClassName="h-7 w-7"
          />
          <IconButton
            icon={isDark ? LogoWhite : LogoBlack}
            iconClassName="h-8 w-8 text-white"
          />
        </div>
      </div>
      <div className="relative h-full flex-1 items-center pt-[72px]">
        <IconLoading className="absolute left-1/2 top-1/2 h-8 w-8 animate-spin" />
      </div>
    </div>
  )
}
